import { render } from "./ImageLightbox.vue?vue&type=template&id=88026340&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=88026340&scoped=true&lang=css"
import "./ImageLightbox.vue?vue&type=style&index=1&id=88026340&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88026340"]])

export default __exports__